// extracted by mini-css-extract-plugin
export var arrow = "DocumentDropdown-module--arrow--aa372";
export var arrowNo = "DocumentDropdown-module--arrow_no--416b1";
export var arrowYes = "DocumentDropdown-module--arrow_yes--6f740";
export var documentDropdownHeader = "DocumentDropdown-module--documentDropdownHeader--e89ea";
export var dropdownChevronIcon = "DocumentDropdown-module--dropdownChevronIcon--a9b59";
export var dropdownContent = "DocumentDropdown-module--dropdownContent--b2e74";
export var dropdownTitle = "DocumentDropdown-module--dropdownTitle--8c446";
export var flex = "DocumentDropdown-module--flex--562b3";
export var flex1 = "DocumentDropdown-module--flex_1--cd3a7";
export var flexCenter = "DocumentDropdown-module--flex_center--0da01";
export var flexCenterCol = "DocumentDropdown-module--flex_center_col--c5d16";
export var flexCol = "DocumentDropdown-module--flex_col--95ca8";
export var flexFixCenterCol = "DocumentDropdown-module--flex_fix_center_col--e1a7c";
export var flexFixedCenterCol = "DocumentDropdown-module--flex_fixed_center_col--f63b8";
export var hiddenIcon = "DocumentDropdown-module--hiddenIcon--0e61d";
export var hideTopBorder = "DocumentDropdown-module--hideTopBorder--e7de6";
export var open = "DocumentDropdown-module--open--fe1d9";
export var rotating = "DocumentDropdown-module--rotating--8a38d";